import React from 'react';
import PropTypes from 'prop-types';
import HomeRowWrapper from './HomeRowWrapper';
import CollectionSlider from '../../components/widgets/CollectionSlider';
import { statusAccessor } from '../../../shared/utils/AccessorUtils';

const CollectionsHomeRow = ({
    userCollections,
    collections,
    handleRecommendationModalOpen,
    onCardClick,
    labelTextId = ' ',
    className,
    loading,
    labelDefaultMessage,
    subtext,
    isCollectionsOrderLocked,
    addons,
    userLearningAssetsById = {},
    customAccessor=[statusAccessor],
    skipSort = false,
}) => (
    <HomeRowWrapper
        labelTextId={labelTextId}
        labelDefaultMessage={labelDefaultMessage}
        subtext={subtext}
        className={className}
    >
        <CollectionSlider
            isCollectionsOrderLocked={isCollectionsOrderLocked}
            handleRecommendationModalOpen={handleRecommendationModalOpen}
            onCardClick={onCardClick}
            userCollections={userCollections}
            collections={collections}
            loading={loading}
            cardClassName={'col-12 col-sm-12'}
            slidesToShow={4.2}
            cardThumbnailDimension={{ h: 450, w: 450 }}
            customAccessor={customAccessor}
            addons={addons}
            userLearningAssetsById={userLearningAssetsById}
            skipSort={skipSort}
        />
    </HomeRowWrapper>
);

CollectionsHomeRow.propTypes = {
    userCollections: PropTypes.array,
    collections: PropTypes.array,
    handleRecommendationModalOpen: PropTypes.func,
    onCardClick: PropTypes.func,
    labelTextId: PropTypes.string,
    className: PropTypes.string,
    loading: PropTypes.bool,
    subtext: PropTypes.string,
    labelDefaultMessage: PropTypes.string,
    addons: PropTypes.array,
    isCollectionsOrderLocked: PropTypes.bool,
    userLearningAssetsById: PropTypes.object,
    customAccessor: PropTypes.array,
    skipSort: PropTypes.bool
};

export default CollectionsHomeRow;
